import script from "./ServiceRequirementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceRequirementDetail.vue?vue&type=script&setup=true&lang=js"

import "./ServiceRequirementDetail.vue?vue&type=style&index=0&id=020f7a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020f7a28"]])

export default __exports__